import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';
import React from 'react';

const CREATE_TASK = gql`
  mutation CreateTask($input: TaskCreateInput!) {
    createTask(input: $input) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/CreateTask').type;
export type CreateTaskVariables = OperationVariables<typeof CREATE_TASK>;
export type CreateTaskInput = CreateTaskVariables['input'];
export type CreateTaskResult = OperationData<typeof CREATE_TASK>;

export const useCreateTask = () => {
  const tuple = useMutation(CREATE_TASK);

  const [_mutate, result] = tuple;

  // TODO need to refresh the lists and things
  // because a task create can affect the currently visible job's tasks, the job list tasks for a job, the task list

  const mutate = React.useCallback<typeof _mutate>(
    (options) => {
      if (!options.variables) {
        throw new Error('variables are required in useCreateTask');
      }
      return _mutate(
        options.variables && {
          context: { service: 'core' },
          update(cache) {
            cache.evict({ fieldName: 'searchTasks' });
          },
          ...options,
        }
      );
    },
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
